/*
  * ValidatorService
  * @author: Dinesh Kumar P
  * @project: WIR
  * @see: Service to provide validating methods
*/

import { Injectable } from '@angular/core'
@Injectable({
  providedIn: 'root'
})

export class ValidatorService {
  /* ***********To check given value has only didgit not characters************** */
  isDigit (value: any): any {
    return /^\d+$/.test(value)
  }

  /* ***********To check given object is not empty************** */
  isEmptyObject (object: any): any {
    return Object.keys(object).length === 0
  }

  /* ***********To check given email is valid************** */
  isValidEmail (): any {
    return /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
  }
}
